import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    Dialog,
    DialogContent,
    Typography,
    IconButton,
    Button
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import {SecondaryButton} from './StyledButtons';


const DialogTitle = props => {
    const {children, classes, onClose} = props;
    return (
        <MuiDialogTitle disableTypography className="common-modal-title">
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="Close" className="close-button-x" onClick={onClose}>
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
};

export default function Modal(props) {
    const {
        title, onClose, onConfirm, fullWidth, fullScreen, maxWidth, overflowVisible, open,
        confirmButtonText, cancelButtonText, swapConfirmClose = false,
        ...restProps
    } = props;
    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={onClose}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            PaperProps={{
                style: {overflowY: overflowVisible ? 'visible' : 'auto'}
            }}
            {...restProps}
        >
            <div className={classNames({
                'common-modal': true,
                'full-screen': fullScreen,
            })}>
                {!fullScreen && <DialogTitle onClose={onClose}>
                    {title}
                </DialogTitle>}
                <DialogContent style={{overflowY: overflowVisible ? 'visible' : 'auto'}}>
                    {props.children}
                </DialogContent>
                {onConfirm &&
                <DialogActions>
                    <SecondaryButton onClick={swapConfirmClose ? onClose : onConfirm}>
                        {(swapConfirmClose ? cancelButtonText : confirmButtonText) || 'Ok'}
                    </SecondaryButton>
                    <Button onClick={swapConfirmClose ? onConfirm : onClose} color="secondary">
                        {(swapConfirmClose ?  confirmButtonText : cancelButtonText) || 'Cancel'}
                    </Button>
                </DialogActions>}
            </div>
        </Dialog>
    );
}

Modal.propTypes = {
    title: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    fullWidth: PropTypes.bool.isRequired,
    fullScreen: PropTypes.bool.isRequired,
    maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]).isRequired,
    overflowVisible: PropTypes.bool.isRequired,
    children: PropTypes.node,
};

Modal.defaultProps = {
    open: false,
    fullWidth: true,
    fullScreen: false,
    maxWidth: 'sm',
    overflowVisible: false,
};
